goog.provide('el8.data.apptRooms');

goog.require('el8.model.base');
goog.require('el8.service.urls');

el8.data.apptRooms = (function() {
    var _class = function(spec) { this.populate(spec); };
    _class.inheritsFrom(el8_Entity);
    _class.makeSortable();
    _class.makeDeleteable();

    _class.addStringProperty('name', true);


    var that =  new el8_EntitySet({
        model: function(spec) { return new _class(spec); },
        urlLoad: function() { return el8.service.urls.get('apptRooms'); },
        urlFn: function(id) { return el8.service.urls.get('apptRooms', [id]); },
        urlSort: function() { return el8.service.urls.get('sortApptRooms'); },
        saveFn: function(item, successCb, errorCb, opts) {
            $.el8_ajax({
                type: 'POST',
                url: el8.service.urls.get('apptRooms', [item.getId()]),
                data: JSON.stringify(item.asMap()),
                success: function(data) {
                    item.populate(data);
                    successCb(data);
                },
                error: errorCb
            });
        },
        deleteFn: function(item, successCb, errorCb, opts) {
            $.el8_ajax({
                type: 'DELETE',
                url: el8.service.urls.get('apptRooms', [item.getId()]),
                success: successCb,
                error: errorCb
            });
        }
    });
    that.makeSetSortable();

    return that;

})();